import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Link, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ConstructionIcon from "@mui/icons-material/Construction";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import { Divider } from "@mui/material";

const drawerWidth = 260;

const itemStyle = {
  py: "12px",
  px: 0,
  borderRadius: "13px",
  color: "#333",
  border: "1px solid transparent",
  transition: "border 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    bgcolor: "#a9d8f7",
    border: "1px solid #0f0fa9",
  },
  "&:focus-visible": {
    bgcolor: "#a9d8f7",
    border: "1px solid #0f0fa9",
    outline: "none",
  },
  "&:active": {
    bgcolor: "#a9d8f7",
    border: "1px solid #0f0fa9",
  },
};

const activeStyle = {
  color: "#000",
  bgcolor: "#a9d8f7",
  fontWeight: "bold",
  borderRadius: "13px",
};

const navItems = [
  {
    label: "CCRA Tool",
    to: "/",
    icon: <ConstructionIcon />,
  },
  ...(process.env.REACT_APP_ENV !== "prod"
    ? [
        {
          label: "CCRA Tool V2",
          to: "/version2",
          icon: <AutorenewIcon />,
        },
      ]
    : []),
  {
    label: "VFD Fan & Control Upgrade",
    to: "/vfd",
    icon: <SettingsInputComponentIcon />,
  },
];


export default function Sidebar() {
  const location = useLocation();

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 2,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            bgcolor: "#def3ff",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", mt: "1rem" }}>
          <List>
            {navItems.map(({ label, to, icon }) => {
              const isActive = (() => {
                if (to === "/") {
                  return (
                    location.pathname === "/" ||
                    (location.pathname.startsWith("/") &&
                      !location.pathname.startsWith("/vfd") &&
                      !location.pathname.startsWith("/version2"))
                  );
                }
                return location.pathname.startsWith(to);
              })();

              return (
                <ListItem
                  disablePadding
                  key={label}
                  sx={{
                    bgcolor: isActive ? "#a9d8f7" : "transparent",
                    margin: "15px",
                    borderRadius: "13px",
                    width: "90%",
                  }}
                >
                  <ListItemButton
                    disablePadding
                    component={Link}
                    to={to}
                    sx={{ ...itemStyle, ...(isActive ? activeStyle : {}) }}
                  >
                    <ListItemIcon
                      sx={{
                        color: "#1976d2",
                        marginLeft: "10px",
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{ fontSize: "0.9rem" }}
                      sx={{ color: "#000" }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}
